export const LastUpdated = '17 Décembre 2025';
